import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Building2, IdCard, Ban } from "lucide-react";

/**
 * Big pill-tab category selector for the SuperAdmin dashboard.
 * Splits the dashboard into 2 main categories:
 *   - Obediențe   (lodges + admins management)
 *   - Pașapoarte  (national passport-number stock)
 */
export default function SuperAdminCategoryTabs({ active }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isPassports = active === "passports" || location.pathname.includes("passport");
  const isBrowser = active === "browser" || location.pathname === "/superadmin/passports";
  const isSuspensions = active === "suspensions" || location.pathname.includes("suspensions");

  const tabs = [
    {
      key: "obediences",
      label: t("superAdminCategoryTabs.obediences"),
      sub: t("superAdminCategoryTabs.lodges_admins_access"),
      icon: <Building2 size={18} />,
      to: "/superadmin",
    },
    {
      key: "passports",
      label: t("superAdminCategoryTabs.passport_stock"),
      sub: t("superAdminCategoryTabs.national_passport_number_reserves"),
      icon: <IdCard size={18} />,
      to: "/superadmin/passport-numbers",
    },
    {
      key: "browser",
      label: t("superAdminCategoryTabs.passport_folders"),
      sub: t("superAdminCategoryTabs.obedience_lodge_member_tree"),
      icon: <IdCard size={18} />,
      to: "/superadmin/passports",
    },
    {
      key: "suspensions",
      label: t("superAdminCategoryTabs.mobile_suspensions", "Suspendări mobil"),
      sub: t("superAdminCategoryTabs.mobile_suspensions_sub", "Blochează aplicația pentru neplată"),
      icon: <Ban size={18} />,
      to: "/superadmin/suspensions",
    },
  ];

  // Avoid t() warnings when keys are missing:
  void t;

  return (
    <div
      data-testid="sa-category-tabs"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: 14,
        marginBottom: "1.6rem",
      }}
    >
      {tabs.map((tab) => {
        const isActive =
          (tab.key === "suspensions" && isSuspensions) ||
          (tab.key === "browser" && isBrowser) ||
          (tab.key === "passports" && isPassports && !isBrowser) ||
          (tab.key === "obediences" && !isPassports && !isBrowser && !isSuspensions);
        return (
          <button
            key={tab.key}
            data-testid={`sa-cat-${tab.key}`}
            onClick={() => {
              if (location.pathname !== tab.to) navigate(tab.to);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              padding: "0.95rem 1.25rem",
              border: isActive ? "1.5px solid #c9a84c" : "1px solid #d8c98a",
              background: isActive
                ? "linear-gradient(135deg,#fdf4e0 0%,#f3e2b2 100%)"
                : "rgba(255,255,255,0.55)",
              boxShadow: isActive
                ? "0 4px 14px rgba(201,168,76,0.25)"
                : "0 2px 6px rgba(0,0,0,0.05)",
              cursor: "pointer",
              textAlign: "left",
              fontFamily: "Cinzel, serif",
              borderRadius: 6,
              transition: "all 0.15s ease",
            }}
          >
            <span
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: isActive ? "#c9a84c" : "#e8d59a",
                color: "#0d1b2a",
              }}
            >
              {tab.icon}
            </span>
            <span style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "0.95rem", letterSpacing: "0.16em", color: "#0d1b2a" }}>
                {tab.label}
              </span>
              <span
                style={{
                  fontFamily: "Crimson Text, serif",
                  fontSize: "0.85rem",
                  color: "#6a5d2c",
                  marginTop: 2,
                }}
              >
                {tab.sub}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
